
// 「カラム名: 値」の集合（AND 条件）
// 値は 1つ(string) でも 複数(string[]) でもOK（複数はIN条件扱い）
export type AutoRuleValue = string | string[];
export type AutoRule = Record<string, AutoRuleValue>;

// 自動ルール（後方互換あり）
// - 旧形式: { gender: 'WOMENS', brand_name_kana: 'タトラス' }
// - 新形式: { filters: { ... }, limit: 5 }
export type AutoRuleSpec =
  | AutoRule
  | {
      filters: AutoRule;
      limit?: number;
    };

export type MattertagProductConfig = {
  /** 固定で表示する item_code */
  fixedItemCodes?: string[];
  /** 自動で追加表示する条件（ルールの数だけ “最新N件” を取得） */
  autoRules?: AutoRuleSpec[];
  /** 自動取得のデフォルト件数（未指定ならフロント側デフォルトを使用） */
  autoLimit?: number;
};

export const MATTERTAG_PRODUCT_CONFIG: Record<string, MattertagProductConfig> = {
  /** 1F-A-001 */
  "qRNoAbgYziN": {
    fixedItemCodes: ["1001239100002", "1001207500031"],
  },
  /** 1F-A-002 */
  "TthQYFadDr5": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "フィルソン",
          "category_code": "shirt-blouse",
        },
        limit: 30,
      },
    ],
  },
  /** 1F-A-003 */
  "JlHlGT9BJXu": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "フィルソン",
          "category_code": ["shirt-blouse", "blouson", "tailored-jacket", "belt", "auto-other-fashion-accessories", "interior"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-A-004 */
  "lwjyTniRCQy": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "フィルソン",
          "category_code": ["tote-bag", "boston-bag", "cap", "knit-cap-beanies", "gloves", "wallet", "coin-purses", "pouch", "card-case"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-A-005 */
  "0jll95r6FdT": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "フィルソン",
          "category_code": ["tshirt-cutsew", "backpack-rucksack", "socks"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-B-001 */
  "2DMlwKrJoq5": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "カウラム",
          "category_code": ["tailored-jacket", "shirt-blouse", "tshirt-cutsew", "sweatpants"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-B-002 */
  "4AW8lhsbITD": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "カウラム",
          "category_code": ["denim-pants", "ma1", "shirt-blouse"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-B-003 */
  "02vE5T1p7sE": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "カウラム",
          "category_code": ["other-outer", "tailored-jacket"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "カウラム",
          "category_code": "tshirt-cutsew",
          "display_color_name": ["ホワイト", "オフホワイト", "ナチュラル", "ベージュ"],
        },
        limit: 15,
      },
    ],
  },
  /** 1F-B-004 */
  "FEMIEHu83BX": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "カウラム",
          "category_code": "sweat",
          "display_color_name": ["ホワイト", "オフホワイト", "ナチュラル", "グレー", "ライトグレー"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "カウラム",
          "category_code": ["tank-tops", "chino-pants"],
        },
        limit: 15,
      },
    ],
  },
  /** 1F-B-005 */
  "rfW9ShDhtvf": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "カウラム",
          "category_code": "tshirt-cutsew",
          "display_color_name": ["ホワイト", "オフホワイト", "ナチュラル", "キャメル", "モカ"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "カウラム",
          "category_code": "other-lifestyle-accessories",
        },
        limit: 15,
      },
    ],
  },
  /** 1F-C-001 */
  "8D9qWf90vTQ": {
    fixedItemCodes: ["1153248901559", "1340248900127", "1300248900341", "1120248902706"],
  },
  /** 1F-C-003 */
  "gTZilErj5Yb": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "brand_name_kana": "ダントン",
        },
        limit: 30,
      },
    ],
  },
  /** 1F-C-004 */
  "XChCL3gFcDg": {
    fixedItemCodes: ["1153248901563"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": "tshirt-cutsew",
          "display_color_name": ["ピンク", "コーラルピンク", "レモンイエロー", "イエロー", "サックスブルー", "ホワイト", "オフホワイト", "ブラック"],
        },
        limit: 29,
      },
    ],
  },
  /** 1F-C-005 */
  "SyqvyEs55V1": {
    fixedItemCodes: ["1146132800014"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": ["slacks", "camisole"],
          "display_color_name": ["ベージュ", "チャコールグレー", "ライトグレー"],
        },
        limit: 29,
      },
    ],
  },
  /** 1F-C-006 */
  "ODKKrKeKoak": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "レスポートサック",
        },
        limit: 30,
      },
    ],
  },
  /** 1F-C-007 */
  "RZAlCvyavjY": {
    fixedItemCodes: ["1113248903344", "1106248900672", "1342248901201", "1120248902692"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": ["tailored-jacket", "slacks", "camisole"],
          "display_color_name": ["ブラック", "ネイビー"],
        },
        limit: 26,
      },
    ],
  },
  /** 1F-D-001 */
  "NTKWqEEfhSI": {
    fixedItemCodes: ["1100254200002", "1142254200002", "1100254200003", "1143254200002", "1174248900443"],
  },
  /** 1F-D-002 */
  "LKvm7YfakQj": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "brand_name_kana": "エルエルビーン",
          "category_code": "blouson",
        },
        limit: 30,
      },
    ],
  },
  /** 1F-D-003 */
  "LzfB1dDyXeN": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "brand_name_kana": "フルーツオブザルーム",
          "category_code": "shirt-blouse",
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": "denim-pants",
        },
        limit: 15,
      },
    ],
  },
  /** 1F-D-004 */
  "tHSxTmXxRXB": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": "blouson",
          "display_color_name": ["ホワイト", "オフホワイト", "ナチュラル", "マスタード", "ベージュ", "ライトグレー"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": ["denim-pants", "cargo-pants", "chino-pants"],
          "display_color_name": ["ホワイト", "ベージュ"],
        },
        limit: 15,
      },
    ],
  },
  /** 1F-D-006 */
  "I91EUiYxd7a": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": ["shirt-blouse", "denim-pants"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-D-007 */
  "XWdklk67KBl": {
    fixedItemCodes: ["1170240100062", "1170325000080", "1170325000058", "1170240100047", "1170240100059"],
  },
  /** 1F-D-008 */
  "9KQ99YyrMHy": {
    fixedItemCodes: ["1170137900031"],
  },
  /** 1F-D-005 */
  "gXDdgdCQzC1": {
    fixedItemCodes: ["1134248901521"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": ["chino-pants", "denim-pants"],
          "display_color_name": ["その他", "その他/柄１", "レオパード", "プリント/柄", "その他/柄６"],
        },
        limit: 29,
      },
    ],
  },
  /** 1F-D-009 */
  "gaXOVuUL94Y": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": "sweat",
        },
        limit: 30,
      },
    ],
  },
  /** 1F-D-010 */
  "7DyU3zrWUjn": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": "shirt-blouse",
          "display_color_name": ["ホワイト", "サックスブルー", "ブルー"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": "shirt-blouse",
          "display_color_name": ["その他", "その他/柄１", "プリント/柄", "その他/柄６"],
        },
        limit: 15,
      },
    ],
  },
  /** 1F-D-011 */
  "Fl8sPUljlMR": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "category_code": "mods-coat",
        },
        limit: 30,
      },
    ],
  },
  /** 1F-D-012 */
  "g5Kj6xZ54c3": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "brand_name_kana": "リー",
        },
        limit: 30,
      },
    ],
  },
  /** 1F-D-013 */
  "fU2ejjaxmai": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "category_code": "riders-jacket",
        },
        limit: 30,
      },
    ],
  },
  /** 1F-D-014 */
  "BEa3frb15jD": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "brand_name_kana": "フルーツオブザルーム",
          "display_color_name": ["レッド", "グレー", "ピンク", "コーラルピンク", "ライトピンク", "ホワイト", "ベージュ"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-D-015 */
  "XLwnFygxIut": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "brand_name_kana": "フルーツオブザルーム",
          "display_color_name": ["ボーダー/ストライプ", "サックスブルーターコイズブルー", "ブルー", "ネイビー", "ダークネイビー"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-D-016 */
  "EupqzAnr6UQ": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "brand_name_kana": "フルーツオブザルーム",
          "category_code": ["sweat", "cardigan-bolero"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-D-017 */
  "3KsmC4rb4uZ": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "brand_name_kana": "フルーツオブザルーム",
          "category_code": ["sweatpants", "other-pants", "knit-sweater", "tshirt-cutsew"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-D-018 */
  "CzGSuto8ohh": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "brand_name_kana": "フルーツオブザルーム",
          "category_code": ["sweat", "cardigan-bolero"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": ["cap", "pumps"],
        },
        limit: 15,
      },
    ],
  },
  /** 1F-E-002 */
  "bHHmvtBFce0": {
    fixedItemCodes: ["1842428400001", "1822252400045", "1182289100006", "1871252400001"],
  },
  /** 1F-E-003 */
  "NELiqOh9zrr": {
    fixedItemCodes: ["1852252400012"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "フリーダ",
          "category_code": ["denim-jacket", "cardigan-bolero", "other-pants", "shirt-blouse"],
        },
        limit: 29,
      },
    ],
  },
  /** 1F-E-005 */
  "1jyiBQPIsbV": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "フリーダ",
          "category_code": ["skirt", "tshirt-cutsew", "other-pants", "denim-pants"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-E-007 */
  "Q6bARQd6SBm": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "フリーダ",
          "category_code": "sweat",
        },
        limit: 30,
      },
    ],
  },
  /** 1F-E-008 */
  "HgAABYPjScs": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "フリーダ",
          "category_code": ["dress", "other-pants"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-E-009 */
  "sJebe6262mH": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "フリーダ",
          "category_code": ["denim-pants", "tshirt-cutsew"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "brand_name_kana": "リー",
          "category_code": ["salopette-overalls", "denim-jacket"],
        },
        limit: 15,
      },
    ],
  },
  /** 1F-E-010 */
  "A1vTYKMnc4d": {
    fixedItemCodes: ["1156311600002", "1334248900387"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "フリーダ",
          "category_code": "other-pants",
        },
        limit: 28,
      },
    ],
  },
  /** 1F-E-011 */
  "8E1FmuVpgyV": {
    fixedItemCodes: ["1871252400001"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "brand_name_kana": "リー",
          "category_code": "denim-jacket",
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": "denim-pants",
        },
        limit: 14,
      },
    ],
  },
  /** 1F-F-001 */
  "IaOo0VgvnYO": {
    fixedItemCodes: ["105922060005"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "リー",
          "category_code": "denim-pants",
        },
        limit: 29,
      },
    ],
  },
  /** 1F-F-002 */
  "71bh4GhW9w0": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "リー",
          "category_code": "denim-jacket",
        },
        limit: 30,
      },
    ],
  },
  /** 1F-F-003 */
  "rEwwX1uLEdD": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "バブアー",
          "category_code": "blouson",
        },
        limit: 30,
      },
    ],
  },
  /** 1F-F-004 */
  "u3Na6H3n432": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "アンブロ",
          "category_code": ["nylon-jacket", "cap", "backpack-rucksack"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-F-005 */
  "5lobziw5xIf": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "アンブロ",
          "category_code": ["cap", "shoulder-bag"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-F-006 */
  "NC3rBigZSkj": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "アディダス",
          "category_code": ["denim-pants", "jersey"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-F-007 */
  "FmKDyUGbRyF": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "アンブロ",
          "category_code": ["shoulder-bag", "hand-bag", "backpack-rucksack"],
        },
        limit: 30,
      },
    ],
  },
  /** 1F-F-008 */
  "Z9EJOJb4TQd": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "アンブロ",
          "category_code": "blouson",
          "display_color_name": ["グレー", "ダークグレー", "チャコールグレー"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "category_code": "denim-pants",
        },
        limit: 15,
      },
    ],
  },
  /** 1F-F-009 */
  "9T0aXv0sne7": {
    fixedItemCodes: ["1159325000029"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "アンブロ",
          "category_code": ["blouson", "denim-pants", "denim-jacket"],
        },
        limit: 29,
      },
    ],
  },
  /** 2F-A-002 */
  "MQMjFKavrjS": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "ヨセミテストラップ",
        },
        limit: 30,
      },
    ],
  },
  /** 2F-A-003 */
  "HVQCc338ynu": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "ナンガ",
          "category_code": "tshirt-cutsew",
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "コールマン",
          "category_code": "backpack-rucksack",
        },
        limit: 15,
      },
    ],
  },
  /** 2F-A-004 */
  "CmSiz4ujaYX": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "setup",
        },
        limit: 30,
      },
    ],
  },
  /** 2F-A-005 */
  "mPg5v6PoNnd": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": ["shirt-blouse", "nylon-jacket"],
          "display_color_name": ["その他", "ボーダー/ストライプ", "プリント/柄", "その他/柄６"],
        },
        limit: 30,
      },
    ],
  },
  /** 2F-A-006 */
  "5Gve1hfLbCS": {
    fixedItemCodes: ["1051207500184", "1045207500034"],
  },
  /** 2F-A-007 */
  "ep1w5CbbU8E": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "ノーティカ",
          "category_code": ["blouson", "other-pants"],
          "display_color_name": "カモフラージュ",
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "ノーティカ",
          "category_code": ["denim-jacket", "denim-pants"],
        },
        limit: 15,
      },
    ],
  },
  /** 2F-A-008 */
  "dsTKZXkUHM7": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "blouson",
          "display_color_name": ["ベージュ", "ブラウン", "ダークブラウン"],
        },
        limit: 10,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "sweat",
          "display_color_name": ["グレー", "ダークグレー", "チャコールグレー.ブラック"],
        },
        limit: 10,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "shirt-blouse",
          "display_color_name": "レオパード",
        },
        limit: 10,
      },
    ],
  },
  /** 2F-A-009 */
  "EmrZdHEypzt": {
    fixedItemCodes: ["1051207500179"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "ノーティカ",
          "category_code": "parka",
        },
        limit: 29,
      },
    ],
  },
  /** 2F-A-010 */
  "TBhx32Lf8nW": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "ノーティカ",
          "category_code": ["parka", "sweatpants"],
        },
        limit: 30,
      },
    ],
  },
  /** 2F-A-012 */
  "OVdd9KvWKzD": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "brand_name_kana": "ノーティカ",
          "category_code": ["parka", "sweatpants"],
        },
        limit: 30,
      },
    ],
  },
  /** 2F-A-013 */
  "DVkkmtZSloB": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "ノーティカ",
          "category_code": "knit-sweater",
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "denim-pants",
        },
        limit: 15,
      },
    ],
  },
  /** 2F-A-014 */
  "jNeuchey1Ym": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "tailored-jacket",
          "display_color_name": ["グレー", "ダークグレー", "チャコールグレー.ブラック"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "WOMENS",
          "category_code": "shirt-blouse",
          "display_color_name": ["グレー", "ダークグレー", "チャコールグレー.ブラック", "ネイビー"],
        },
        limit: 15,
      },
    ],
  },
  /** 2F-A-015 */
  "rjLG7EjkmE8": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "イジピジ",
          "category_code": "eyeglasses-sunglasses",
        },
        limit: 30,
      },
    ],
  },
  /** 2F-A-016 */
  "iyog4bfMHlJ": {
    fixedItemCodes: ["1153408400007", "1244248900247", "1081207500434"],
  },
  /** 2F-B-001 */
  "SBjcnSbFgkS": {
    fixedItemCodes: ["1002179700001"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "リー",
          "category_code": ["denim-jacket", "denim-pants"],
        },
        limit: 29,
      },
    ],
  },
  /** 2F-B-002 */
  "cu8Qv06dB8J": {
    fixedItemCodes: ["1043248901210"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "アンブロ",
          "category_code": "blouson",
          "display_color_name": ["ブラウン", "ダークブラウン", "オリーブ"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "アディダス",
          "category_code": ["jersey", "denim-pants"],
        },
        limit: 14,
      },
    ],
  },
  /** 2F-B-003 */
  "ZXQBIuaXJEW": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "プーマ",
          "category_code": "sneakers",
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "cap",
          "display_color_name": ["ホワイト", "グレー", "ネイビー", "ブルー", "ブラウン", "ダークブラウン"],
        },
        limit: 15,
      },
    ],
  },
  /** 2F-B-004 */
  "p4mEzGaLC0n": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "riders-jacket",
          "display_color_name": ["ブラウン", "ダークブラウン", "ブラック", "モカ", "キャラメル"],
        },
        limit: 10,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "shirt-blouse",
          "display_color_name": ["ブラック", "その他", "プリント/柄", "その他/柄６"],
        },
        limit: 10,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "sweat",
          "display_color_name": "チャコールグレー",
        },
        limit: 10,
      },
    ],
  },
  /** 2F-B-005 */
  "YvY9D5k41ta": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": ["sweat", "sweatpants"],
          "display_color_name": ["レッド", "ワインレッド", "レンガ", "ベージュ", "キャメル", "モカ", "グレー", "ダークグレー", "チャコールグレー"],
        },
        limit: 30,
      },
    ],
  },
  /** 2F-B-006 */
  "fv6Y7WKQqs0": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "riders-jacket",
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": ["denim-jacket", "denim-pants"],
        },
        limit: 15,
      },
    ],
  },
  /** 2F-B-007 */
  "z3XczypQY9G": {
    fixedItemCodes: ["1051333700039", "3343234400035", "1002179700001"],
  },
  /** 2F-B-008 */
  "qepgMupCqGT": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "shirt-blouse",
          "display_color_name": ["ボーダー/ストライプ", "プリント/柄", "その他/柄６", "その他/柄１", "サックスブルー", "ホワイト"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "slacks",
          "display_color_name": ["チャコールグレー", "ダークグレー", "ネイビー"],
        },
        limit: 15,
      },
    ],
  },
  /** 2F-C-001 */
  "GOJswxbWsBY": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "カウラム",
          "category_code": "tshirt-cutsew",
          "display_color_name": "ホワイト",
        },
        limit: 10,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "shirt-blouse",
          "display_color_name": ["グレー", "ダークグレー"],
        },
        limit: 10,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "slacks",
          "display_color_name": ["グレー", "ダークグレー"],
        },
        limit: 10,
      },
    ],
  },
  /** 2F-C-002 */
  "csc4MSJRUuV": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "カウラム",
          "category_code": ["ma1", "other-outer"],
        },
        limit: 30,
      },
    ],
  },
  /** 2F-C-003 */
  "sKK5F1uldes": {
    fixedItemCodes: ["1070204102387"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": ["tank-tops", "tshirt-cutsew"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "brand_name_kana": "カウラム",
          "category_code": "socks",
        },
        limit: 14,
      },
    ],
  },
  /** 2F-D-001 */
  "4vijCU5RBsM": {
    fixedItemCodes: ["1043046300002", "1251248900728", "1082239100002"],
  },
  /** 2F-D-002 */
  "HrNIl4fKN3Q": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "mods-coat",
          "display_color_name": ["グレー", "ダークグレー"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": ["ma1", "riders-jacket"],
        },
        limit: 15,
      },
    ],
  },
  /** 2F-D-004 */
  "KHvHZwbDvBi": {
    fixedItemCodes: ["1053248900601"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": ["sweat", "tshirt-cutsew"],
          "display_color_name": ["ホワイト", "ブルー", "サックスブルー", "ターコイズブルー"],
        },
        limit: 10,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "mods-coat",
          "display_color_name": "オリーブ",
        },
        limit: 10,
      },
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "riders-jacket",
          "display_color_name": ["ダークブラウン", "ブラウン", "ブラック"],
        },
        limit: 9,
      },
    ],
  },
  /** 2F-D-005 */
  "Ep0ZqIb2kg2": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": ["denim-jacket", "tshirt-cutsew"],
          "display_color_name": ["ブラック", "グレー", "ダークグレー", "ブラウン"],
        },
        limit: 30,
      },
    ],
  },
  /** 2F-D-006 */
  "uF3bC3CT5qB": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": ["blouson", "riders-jacket"],
          "display_color_name": ["ブラウン", "ベージュ", "モカ", "キャメル"],
        },
        limit: 15,
      },
      {
        filters: {
          "is_public": "0",
          "category_code": ["tshirt-cutsew", "slacks"],
          "display_color_name": ["ブラック", "ブラウン"],
        },
        limit: 15,
      },
    ],
  },
  /** 2F-D-007 */
  "4RC9yHunxqs": {
    fixedItemCodes: ["1003311600001"],
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "レッドキャップ",
          "category_code": ["shirt-blouse", "parka"],
        },
        limit: 29,
      },
    ],
  },
  /** 2F-D-008 */
  "H45DoRbbppR": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "レッドキャップ",
          "category_code": ["denim-pants", "chino-pants"],
        },
        limit: 30,
      },
    ],
  },
  /** 2F-D-009 */
  "S1iCNDa4CYm": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "レッドキャップ",
          "category_code": ["tailored-jacket", "slacks"],
        },
        limit: 30,
      },
    ],
  },
  /** 2F-D-009 */
  "8LrprF4MsGL": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "brand_name_kana": "レッドキャップ",
          "category_code": ["tailored-jacket", "slacks"],
        },
        limit: 30,
      },
    ],
  },
  /** 2F-D-010 */
  "2TB2FYjaUcj": {
    autoRules: [
      {
        filters: {
          "is_public": "0",
          "gender": "MENS",
          "category_code": "dress-shoes",
          "display_color_name": "ブラック",
        },
        limit: 30,
      },
    ],
  },
  /** 1F-C-002 */
  "GYL6KpThlUc": {
  fixedItemCodes: ["1124148200001"],
},
};
